var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"greetings home__section"},[_c('h2',{staticClass:"greetings__title"},[_vm._v("歡迎來到空英老師專區！")]),_c('p',[_vm._v("空英老師專區提供給每位使用空中英語教室系列雜誌的教師，進行延伸教學及課堂評量，成為最完整的教學資源。")]),_c('p',[_vm._v("您可按照教學上的需要，選擇當月全部下載，或是依照年月份選擇個別下載。")])])
}]

export { render, staticRenderFns }